import React, { useState } from 'react';
import {
    CircleStackIcon,
    BoltIcon,
    MapIcon,
    ShareIcon,
    MicrophoneIcon,
    CurrencyDollarIcon,
    GlobeAmericasIcon,
    ChevronDownIcon,
    InformationCircleIcon
} from '@heroicons/react/24/outline';

export interface DimensionDefinition {
    name: string;
    description: string;
    icon: React.ElementType;
}

export const definitions: DimensionDefinition[] = [
    {
        name: 'DATA',
        description: 'Detailed record of production activity & investments for reference & analysis',
        icon: CircleStackIcon,
    },
    {
        name: 'AGILITY',
        description: 'The speed & ease of content creation',
        icon: BoltIcon,
    },
    {
        name: 'GOVERNANCE',
        description: 'Structures & processes in place to ensure accountability & transparency',
        icon: MapIcon,
    },
    {
        name: 'PARTNER MIX',
        description: 'Composition, characteristics, behaviors, & capabilities of the advertiser\'s suppliers & supplier ecosystem',
        icon: ShareIcon,
    },
    {
        name: 'MARKETER LEADERSHIP',
        description: 'Characteristics, behaviors, & capabilities of the advertiser\'s content creation organization',
        icon: MicrophoneIcon,
    },
    {
        name: 'VALUE',
        description: 'Relative worth, utility, or importance of investments, both internal and external',
        icon: CurrencyDollarIcon,
    },
    {
        name: 'SOCIAL RESPONSIBILITY',
        description: 'Balance between economic growth & welfare of the society & environment',
        icon: GlobeAmericasIcon,
    },
];

const MaturityDefinitions: React.FC = () => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-6">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
            >
                <div className="flex items-center space-x-2">
                    <InformationCircleIcon className="h-5 w-5 text-gray-500" />
                    <h3 className="text-lg font-semibold text-gray-900">Dimensions Definitions</h3>
                </div>
                <ChevronDownIcon
                    className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''
                        }`}
                />
            </button>

            <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
            >
                <div className="p-4 sm:p-6">
                    {/* Dimensions Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        {definitions.map((def) => (
                            <div
                                key={def.name}
                                className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col items-start"
                            >
                                <div className="flex items-center space-x-3 mb-3 w-full">
                                    <div className="p-2 bg-indigo-50 rounded-full flex-shrink-0">
                                        <def.icon className="h-6 w-6 text-indigo-600" />
                                    </div>
                                    <h4 className="font-bold text-gray-900 text-sm tracking-wide uppercase">
                                        {def.name}
                                    </h4>
                                </div>
                                <p className="text-sm text-gray-600 leading-relaxed">
                                    {def.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaturityDefinitions;
